import { codesNoSDK } from "../Constants/Constants";

export const conditions = {
  successServiceConsume: (_context, event) => event?.data?.response?.data?.resultCode ?? false,
  successServiceJws: (_context, event) => event?.data?.response?.data?.jws ?? false,
  successEncryptKey: (_context, event) => !!(event.data.jwe && event.data.aesKey),
  isCookie: (_context, event) => !!event.data.cookie,
  isError: (_context, event) => !!event.data.error,
  successRefreshKey: (_context, event) => !!event.data.jwe,
  isUnauthorized: (_context, event) => event.data.response.data.resultCode === codesNoSDK.unauthorized.code,
  failedRecatpcha: (_context, event) => event.data.response.data.resultCode === codesNoSDK.failedRecatpcha.code,
  failedRecatpchaChallenge: (_context, event) => event.data.response.data.resultCode === codesNoSDK.failedRecatpchaChallenge.code,
  failedRecatpchaRetry: (_context, event) => event.data.response.data.resultCode === codesNoSDK.failedRecatpchaRetry.code && !_context.challenge,
  successUrlQr: (_context, event) => !!event.data.resultUrl
};
